import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    currentId: 1,
    list: []
  },

  mutations: {
    /**
     * Add notification
     * @param {Object} state vuex state
     * @param {Object} options Notification options
     * @param {string} options.text Notification content
     * @param {number} [options.timeout=6000] Remove notification after ms of passed time
     * @param {('error'|'success')} [options.type] Notification type (changes color)
     */
    add (state, options) {
      const notification = Object.assign({ id: state.currentId++ }, options)

      state.list.unshift(notification)
    },

    /**
     * Remove notification
     * @param {Object} state vuex state
     * @param {number} id Notification id
     */
    remove (state, id) {
      let index = state.list.findIndex(item => item.id === id)
      Vue.delete(state.list, index)
    }
  }
}
